import { render, staticRenderFns } from "./PedidoEnProceso.vue?vue&type=template&id=52c997e2&"
import script from "./PedidoEnProceso.vue?vue&type=script&lang=js&"
export * from "./PedidoEnProceso.vue?vue&type=script&lang=js&"
import style0 from "./PedidoEnProceso.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports